module.exports = __webpack_public_path__ + "img/mobile.37e49f7e.svg";